module.exports = __webpack_public_path__ + "static/gv_logo1-418f92e0ef436b8d70e08cc7b05bfb55.png";